import script from "./installApp.vue?vue&type=script&setup=true&lang=js"
export * from "./installApp.vue?vue&type=script&setup=true&lang=js"

import "./installApp.vue?vue&type=style&index=0&id=393ef29e&scoped=true&lang=less"

import exportComponent from "E:\\A-OnlineServiceCenter\\stableBuilds\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393ef29e"]])

export default __exports__